<template>
  <div>
    <card v-loading="loading" :title="$t('emvClearings.pageSingle.title')">
      <span v-if="error">{{ JSON.stringify(error) }}</span>
      <span v-else-if="details">
      <emv-clearing-details :details="details"/>
    </span>
    </card>
  </div>
</template>
<script>
import EmvClearingDetails from "src/components/EmvClearing/EmvClearingDetails";
import {mapActions, mapState} from "vuex";

export default {
  name: 'EmvClearingPage',
  components: {
    EmvClearingDetails
  },
  methods: {
    ...mapActions(['LoadEmvClearing'])
  },
  computed: {
    ...mapState({
      loading: state => state.emv_clearing.loading,
      details: state => state.emv_clearing.data,
      error: state => state.emv_clearing.error,
    }),
  },
  mounted() {
    if (this.details === null || this.details.id != this.$route.params.id) {
      this.LoadEmvClearing({id: this.$route.params.id})
    }
  }
};
</script>
<style>
</style>
